import Vue from 'vue'
import popDom from './Dialog.vue'
const Confirm = Vue.extend(popDom)

/*
 * cpName: 动态展示组件的展示字符串供Dialog.vue的cpName使用, 直接 importCpObj 对象加个引号变成字符串即可，比如 importCpObj 是 DelCf , cpName 为 'DelCf'
 * importCpObj: 动态组件的引入对象
 * curItem: 当前需要传递给动态组件以及按钮的数据对象
 * propsData: 外部传递给
 */
Confirm.init = function (cpName, importCpObj, curItem, propsData) {
  let instance = null
  let cpObj = {}
  cpObj[cpName] = importCpObj
  let options = {
    data () { return { cpName, curItem, rs: null, rj: null, instance: null } },
    components: cpObj,
    propsData: propsData, // props属性值须传 propsData 为传递值的 key
    methods: {
      closeDialog () {
        document.body.removeChild(instance.vm.$el)
        instance.curItem = {}
        instance.visible = false
        instance.vm.$destroy()
        instance = null
      }
    }
  }
  
  instance = new Confirm(options)
  instance.instance = instance
  let newPromise = new Promise( (rs, rj) => {
    instance.rs = rs
    instance.rj = rj
  })
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  return newPromise // return 一个 promise 拦截此promise的rs rj 参数回调，供后续按钮触发执行外部init初始化时.then里定义的方法
}

export default Confirm
